import { __exports as r } from "./index131.js";
var c;
function u() {
  if (c) return r;
  c = 1, Object.defineProperty(r, "__esModule", { value: !0 }), r.clone = void 0;
  function n(e) {
    if (typeof e != "object")
      return e;
    if (Object.prototype.toString.call(e) === "[object Object]") {
      var o = {};
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (o[t] = n(e[t]));
      return o;
    } else return Array.isArray(e) ? e.map(n) : e;
  }
  return r.clone = n, r;
}
export {
  u as __require
};
//# sourceMappingURL=index109.js.map
